import React from "react";

const RecentActivity = () => {
  return <div className="fs-2 fw-600">RecentActivity</div>;
};

export default RecentActivity;
